var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown)?_c('div',{staticClass:"black-bg",on:{"click":_vm.close}},[_c('vue-scroll',{attrs:{"ops":_vm.ops}},[_c('div',{ref:"clo",staticClass:"close"}),_c('img',{ref:"src",staticClass:"bg-img",attrs:{"src":_vm.src,"alt":""}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }